<template>
    <div class="file-manage">
        <el-header class="overview-header">
            <div class="header-left">
                <img src="@/assets/favicon.png" alt="" />
                <div class="header-text-left">凌丰供应商系统</div>
                <div class="pe-header-text">文件管理</div>
            </div>
            <div class="header-info">
                <div class="header-right">欢迎您，{{ userNme }} ({{ roleName }})</div>
                <div class="header-right">{{ homeDate }}</div>
            </div>
        </el-header>

        <div class="manage-body">
            <div class="file-panel">
                <div class="file-toolbar">
                    <div class="breadcrumb-wrap">
                        <el-breadcrumb separator="/" v-show="!searchQuery">
                            <el-breadcrumb-item class="path-item" v-for="(dir, index) in currentPath" :key="index" @click.native="clickPath(index)">
                                {{ dir }}
                            </el-breadcrumb-item>
                        </el-breadcrumb>
                        <span v-show="searchQuery" class="search-tip">搜索“{{ searchQuery }}”的结果（{{ files.length }} 项）</span>
                    </div>
                    <div class="toolbar-actions">
                        <el-button size="small" icon="el-icon-back" @click="goBackDirectory" v-show="!searchQuery" :disabled="currentPath.length === 1">返回上一层</el-button>
                        <el-button size="small" icon="el-icon-refresh" type="success" plain @click="getData" v-show="!searchQuery"></el-button>
                        <!-- <el-button size="small" icon="el-icon-folder-add" type="primary" plain v-show="!searchQuery" @click="openNewFolder">新建文件夹</el-button> -->
                        <!-- <el-button size="small" icon="el-icon-upload2" type="primary" @click="openUpload">上传文件</el-button> -->
                        <!-- <el-input placeholder="搜索文件名..." v-model="searchQuery" size="small" prefix-icon="el-icon-search" clearable class="search-input" @change="search">
                        </el-input> -->
                    </div>
                </div>

                <div class="file-list" v-loading="listLoading">
                    <div v-if="files.length === 0" class="empty-state">
                        <div class="empty-icon">
                            <i class="el-icon-folder-opened"></i>
                        </div>
                        <p>{{ searchQuery ? "未找到匹配的文件" : "当前目录为空" }}</p>
                        <el-button v-if="!searchQuery" type="text" @click="openUpload">点击上传文件</el-button>
                    </div>

                    <div v-else class="file-scroll">
                        <div v-for="file in files" :key="file.key" class="file-item" @dblclick="dblclickItem(file)">
                            <div class="file-icon" :style="{ color: fileIconColor(file) }">
                                <i :class="fileIcon(file)"></i>
                            </div>
                            <div class="file-info">
                                <div class="file-name" :title="file.name">
                                    <span :class="'file-type-indicator file-type-' + fileTypeClass(file)"></span>
                                    <span>{{ file.name }}</span>
                                </div>
                                <div class="file-meta">
                                    {{ file.isDirectory ? "文件夹" : `${file.size} • ${file.uploadTime} • ${file.type}` }}
                                </div>
                            </div>
                            <div class="file-ops">
                                <el-button v-if="!file.isDirectory" type="success" size="mini" icon="el-icon-download" title="下载" @click="downloadFile(file)">
                                </el-button>
                                <el-button v-if="!file.isDirectory" type="danger" size="mini" icon="el-icon-delete" title="删除" @click="deleteFile(file)">
                                </el-button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <el-footer class="page-footer">© 2024 LINKFAIRTECH 版权所有</el-footer>

        <!-- 上传文件对话框 -->
        <el-dialog title="上传文件" :visible.sync="showUploadDialog" width="50%" :close-on-click-modal="false" @closed="resetUploadState">
            <div class="upload-area" @drop="handleDrop" @dragover="handleDragover" @click="triggerFileInput">
                <div class="upload-icon">
                    <i class="el-icon-upload"></i>
                </div>
                <p>
                    将文件或文件夹拖到此处，或<el-button type="text">选择文件</el-button>
                    <el-button type="text" @click.stop="triggerFolderInput">选择文件夹</el-button>
                </p>
                <p class="upload-target">上传到：文件库{{ currentPath.length ? " / " + currentPath.join(" / ") : "" }}</p>
                <input type="file" ref="fileInput" multiple @click.stop @change="handleFileSelect" style="display: none">
                <input type="file" ref="folderInput" multiple webkitdirectory directory @click.stop @change="handleFolderSelect" style="display: none">
            </div>
            <div v-if="selectedFiles.length > 0 || selectedDirectories.length > 0" class="selected-upload-panel">
                <div class="selected-upload-header">
                    <h4>已选择内容</h4>
                    <span>{{ selectedDirectories.length }} 个文件夹，{{ selectedFiles.length }} 个文件</span>
                </div>
                <ul class="selected-upload-list">
                    <li v-for="directory in selectedDirectories" :key="`directory-${directory}`" class="selected-upload-item">
                        <i class="el-icon-folder selected-upload-icon folder-icon"></i>
                        <span class="selected-upload-name">{{ directory }}/</span>
                        <el-button type="text" class="remove-upload-item" title="取消该文件夹" @click="removeSelectedDirectory(directory)">×</el-button>
                    </li>
                    <li v-for="(item, index) in selectedFiles" :key="`${item.relativePath}-${index}`" class="selected-upload-item">
                        <i class="el-icon-document selected-upload-icon doc-icon"></i>
                        <span class="selected-upload-name">{{ item.relativePath }}</span>
                        <span class="selected-upload-size">{{ formatFileSize(item.file.size) }}</span>
                        <el-button type="text" class="remove-upload-item" title="取消该文件" @click="removeSelectedFile(index)">×</el-button>
                    </li>
                </ul>
            </div>
            <div slot="footer" class="dialog-footer">
                <p v-if="uploading" class="upload-progress">上传进度: {{ uploadProgress }}%</p>
                <el-button @click="showUploadDialog = false" size="small" :disabled="uploading">取消</el-button>
                <el-button type="primary" @click="uploadFiles" :loading="uploading" size="small">
                    {{ uploading ? "上传中..." : "确认上传" }}
                </el-button>
            </div>
        </el-dialog>

        <!-- 新建文件夹对话框 -->
        <el-dialog title="新建文件夹" :visible.sync="newFolderShow" width="30%" :close-on-click-modal="false">
            <div style="display: flex;align-items: center;">
                <div style="width: 90px;">文件夹名称：</div>
                <el-input v-model="newFolderName" placeholder="请输入文件夹名称" size="small" @keyup.enter.native="newFolder"></el-input>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button @click="newFolderShow = false" size="small">关闭</el-button>
                <el-button type="primary" @click="newFolder" size="small" :loading="folderCreating">新增</el-button>
            </div>
        </el-dialog>

        <viewFileMin :file="currentViewFile" :visible="viewOffice" @updateVisible="updateVisible"></viewFileMin>
        <imageView :img_show.sync="img_show" :fileName="currentFileName" :filePath="currentFilePath" @imageClose="imageClose"></imageView>
    </div>
</template>

<script>
import * as fileApi from "@/Api/fileApi";
import viewFileMin from "@/components/viewFileMin.vue";
import imageView from "@/components/imageView.vue";

export default {
    name: "fileManage",
    components: {
        viewFileMin,
        imageView,
    },
    data() {
        return {
            timer: "",
            homeDate: "",
            userNme: sessionStorage.getItem("userName"),
            roleName: sessionStorage.getItem("roleName"),
            files: [],
            currentPath: ['供应商发货附件'],
            searchQuery: "",
            listLoading: false,
            showUploadDialog: false,
            selectedFiles: [],
            selectedDirectories: [],
            uploading: false,
            uploadProgress: 0,
            newFolderShow: false,
            newFolderName: "",
            folderCreating: false,
            currentViewFile: {},
            viewOffice: false,
            img_show: false,
            currentFileName: "",
            currentFilePath: "",
        };
    },
    methods: {
        showTime() {
            this.homeDate = this.$getTime();
            this.timer = setInterval(() => {
                this.homeDate = this.$getTime();
            }, 1000);
        },
        // 加载当前目录
        getData() {
            this.listLoading = true;
            return fileApi
                .getFileListApi(this.currentPath.join("/"), this)
                .then((res) => {
                    const list = res && Array.isArray(res.files) ? res.files : Array.isArray(res) ? res : [];
                    this.files = list.map((item) => this.normalizeDirItem(item));
                })
                .catch(() => {})
                .finally(() => {
                    this.listLoading = false;
                });
        },
        normalizeDirItem(item) {
            const isDirectory = Boolean(item.isDirectory);
            const name = item.name || "";
            return {
                ...item,
                key: `${isDirectory ? "dir" : "file"}-${name}`,
                isDirectory,
                name,
                size: isDirectory ? "" : this.formatFileSize(item.size),
                uploadTime: this.countModified(item.lastModified || item.uploadTime),
                type: isDirectory ? "文件夹" : this.countFileType(name),
            };
        },
        // 全局搜索文件
        search() {
            const keyword = (this.searchQuery || "").trim();
            if (!keyword) {
                this.getData();
                return;
            }
            this.listLoading = true;
            fileApi
                .searchFileListApi({ originalName: keyword }, this)
                .then((res) => {
                    const list = Array.isArray(res) ? res : res && Array.isArray(res.records) ? res.records : [];
                    this.files = list.map((item) => ({
                        ...item,
                        key: `file-${item.id}`,
                        isDirectory: false,
                        name: item.originalName,
                        size: this.formatFileSize(item.size),
                        uploadTime: item.uploadTime || "",
                        type: this.countFileType(item.originalName || ""),
                    }));
                })
                .catch(() => {})
                .finally(() => {
                    this.listLoading = false;
                });
        },
        // 双击：进入文件夹 / 预览文件
        dblclickItem(file) {
            if (this.searchQuery) return;
            if (file.isDirectory) {
                this.currentPath.push(file.name);
                this.getData();
            } else {
                this.previewFile(file);
            }
        },
        clickPath(index) {
            if (index === this.currentPath.length - 1) return;
            this.currentPath.splice(index + 1, this.currentPath.length - index - 1);
            this.getData();
        },
        clickRootPath() {
            if (this.currentPath.length === 0) return;
            this.currentPath = [];
            this.getData();
        },
        goBackDirectory() {
            if (this.currentPath.length === 1 || this.searchQuery) return;
            this.currentPath.pop();
            this.getData();
        },
        // 页面无弹窗且焦点不在输入区域时，Backspace 返回上一层
        handleBackspace(event) {
            if (event.key !== "Backspace" || this.currentPath.length === 0 || this.searchQuery) return;
            if (this.showUploadDialog || this.newFolderShow || this.viewOffice || this.img_show) return;
            const target = event.target;
            const tagName = target && target.tagName ? target.tagName.toLowerCase() : "";
            if (["input", "textarea", "select"].includes(tagName) || (target && target.isContentEditable)) return;
            event.preventDefault();
            this.goBackDirectory();
        },
        fileIcon(file) {
            if (file.isDirectory) return "el-icon-folder-opened";
            if (file.type === "图片") return "el-icon-picture";
            if (file.type === "PDF") return "el-icon-document";
            return "el-icon-document";
        },
        fileIconColor(file) {
            if (file.isDirectory) return "#e6a23c";
            if (file.type === "图片") return "#67c23a";
            if (file.type === "PDF") return "#f56c6c";
            return "#409eff";
        },
        fileTypeClass(file) {
            if (file.isDirectory) return "other";
            if (file.type === "图片") return "image";
            if (file.type === "PDF") return "pdf";
            if (["doc", "docx", "xls", "xlsx"].includes(this.fileExt(file.name))) return "doc";
            return "other";
        },
        fileExt(name) {
            return (name || "").split(".").pop().toLowerCase();
        },
        countFileType(name) {
            if ((name || "").toLowerCase().match(/\.(jpg|jpeg|png|gif|bmp)$/)) return "图片";
            if ((name || "").toLowerCase().match(/\.(pdf)$/)) return "PDF";
            return (name || "").split(".").pop();
        },
        canPreview(file) {
            return file.type === "图片" || file.type === "PDF" || ["doc", "docx", "xls", "xlsx"].includes(this.fileExt(file.name));
        },
        fileLocation(file) {
            return file.path ?? file.id;
        },
        // 预览
        previewFile(file) {
            if (file.isDirectory) return;
            if (file.type === "PDF") {
                fileApi
                    .viewFileApi(this.fileLocation(file), this)
                    .then((blob) => {
                        blob = new Blob([blob], { type: "application/pdf" });
                        const blobUrl = URL.createObjectURL(blob);
                        const newWindow = window.open(blobUrl, "_blank");
                        if (!newWindow || newWindow.closed || typeof newWindow.closed === "undefined") {
                            this.$message.warning("弹出窗口被阻止，请允许浏览器弹出窗口或手动下载后查看");
                            this.downloadBlob(blob, file.name);
                        }
                    })
                    .catch(() => {});
            } else if (file.type === "图片") {
                this.currentFileName = file.name;
                this.currentFilePath = this.fileLocation(file);
                this.img_show = true;
            } else if (["doc", "docx", "xls", "xlsx"].includes(this.fileExt(file.name))) {
                this.currentViewFile = {
                    originalName: file.name,
                    id: this.fileLocation(file),
                };
                this.viewOffice = true;
            } else {
                this.$message.info("该文件类型暂不支持预览，请下载后查看");
            }
        },
        updateVisible(e) {
            this.viewOffice = e;
        },
        imageClose() {
            this.img_show = false;
        },
        // 下载文件
        downloadFile(file) {
            fileApi
                .viewFileApi(this.fileLocation(file), this)
                .then((blob) => {
                    this.downloadBlob(blob, file.name);
                    this.$message.success(`开始下载: ${file.name}`);
                })
                .catch(() => {
                    this.$message.error("文件下载失败，请重试");
                });
        },
        downloadBlob(blob, filename) {
            const url = URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.href = url;
            a.download = filename;
            document.body.appendChild(a);
            a.click();
            setTimeout(() => {
                document.body.removeChild(a);
                URL.revokeObjectURL(url);
            }, 100);
        },
        // 删除文件（无删除目录接口，仅支持文件）
        deleteFile(file) {
            if (file.isDirectory) return;
            this.$confirm(`确定要删除文件 "${file.name}" 吗？`, "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    fileApi
                        .delFileApi(this.fileLocation(file), this)
                        .then(() => {
                            this.$message.success("删除成功");
                            this.searchQuery ? this.search() : this.getData();
                        })
                        .catch(() => {
                            this.$message.error("删除失败");
                        });
                })
                .catch(() => {});
        },
        // 新建文件夹
        openNewFolder() {
            this.newFolderName = "";
            this.newFolderShow = true;
        },
        newFolder() {
            const name = (this.newFolderName || "").trim();
            if (!name) {
                this.$message.warning("请输入文件夹名称");
                return;
            }
            if (/[\\/:*?"<>|]/.test(name)) {
                this.$message.warning('文件夹名称不能包含 \\ / : * ? " < > | 字符');
                return;
            }
            const targetPath = [...this.currentPath, name].join("\\");
            this.folderCreating = true;
            fileApi
                .newFolderApi([targetPath], this)
                .then(() => {
                    this.$message.success("文件夹创建成功");
                    this.newFolderShow = false;
                    this.getData();
                })
                .catch(() => {})
                .finally(() => {
                    this.folderCreating = false;
                });
        },
        // 上传
        openUpload() {
            this.showUploadDialog = true;
        },
        resetUploadState() {
            this.selectedFiles = [];
            this.selectedDirectories = [];
            this.uploadProgress = 0;
        },
        triggerFileInput() {
            this.$refs.fileInput.click();
        },
        async triggerFolderInput() {
            if (typeof window.showDirectoryPicker !== "function") {
                this.$refs.folderInput.click();
                return;
            }
            try {
                const directoryHandle = await window.showDirectoryPicker();
                const selectedFiles = [];
                const selectedDirectories = [];
                await this.readDirectoryHandle(directoryHandle, "", selectedFiles, selectedDirectories);
                this.selectedFiles = selectedFiles;
                this.selectedDirectories = selectedDirectories;
            } catch (error) {
                if (error.name !== "AbortError") {
                    this.$message.error("读取文件夹失败");
                }
            }
        },
        // 递归读取选择的文件夹，包括空文件夹
        async readDirectoryHandle(directoryHandle, parentPath, selectedFiles, selectedDirectories) {
            const relativePath = parentPath ? `${parentPath}/${directoryHandle.name}` : directoryHandle.name;
            selectedDirectories.push(relativePath);
            for await (const handle of directoryHandle.values()) {
                if (handle.kind === "file") {
                    const file = await handle.getFile();
                    selectedFiles.push({
                        file,
                        relativePath: `${relativePath}/${file.name}`,
                    });
                } else {
                    await this.readDirectoryHandle(handle, relativePath, selectedFiles, selectedDirectories);
                }
            }
        },
        handleFileSelect(event) {
            this.selectedDirectories = [];
            this.selectedFiles = Array.from(event.target.files).map((file) => ({
                file,
                relativePath: file.name,
            }));
            event.target.value = "";
        },
        async handleFolderSelect(event) {
            const entries = Array.from(event.target.webkitEntries || []);
            if (entries.some((entry) => entry.isDirectory)) {
                const selectedFiles = [];
                const selectedDirectories = [];
                for (const entry of entries) {
                    await this.readDroppedEntry(entry, "", selectedFiles, selectedDirectories);
                }
                this.selectedFiles = selectedFiles;
                this.selectedDirectories = selectedDirectories;
            } else {
                this.selectedDirectories = [];
                this.selectedFiles = Array.from(event.target.files).map((file) => ({
                    file,
                    relativePath: file.webkitRelativePath || file.name,
                }));
            }
            event.target.value = "";
        },
        async handleDrop(event) {
            event.preventDefault();
            const items = Array.from(event.dataTransfer.items || []);
            const entries = items.map((item) => item.webkitGetAsEntry && item.webkitGetAsEntry()).filter(Boolean);
            if (entries.length === 0) {
                this.selectedDirectories = [];
                this.selectedFiles = Array.from(event.dataTransfer.files).map((file) => ({
                    file,
                    relativePath: file.name,
                }));
                return;
            }
            const selectedFiles = [];
            const selectedDirectories = [];
            for (const entry of entries) {
                await this.readDroppedEntry(entry, "", selectedFiles, selectedDirectories);
            }
            this.selectedFiles = selectedFiles;
            this.selectedDirectories = selectedDirectories;
        },
        // 递归读取拖拽的文件和文件夹
        async readDroppedEntry(entry, parentPath, selectedFiles, selectedDirectories) {
            const relativePath = parentPath ? `${parentPath}/${entry.name}` : entry.name;
            if (entry.isFile) {
                const file = await new Promise((resolve, reject) => entry.file(resolve, reject));
                selectedFiles.push({ file, relativePath });
                return;
            }
            selectedDirectories.push(relativePath);
            const reader = entry.createReader();
            let entries = [];
            let batch = [];
            do {
                batch = await new Promise((resolve, reject) => reader.readEntries(resolve, reject));
                entries = entries.concat(batch);
            } while (batch.length > 0);
            for (const childEntry of entries) {
                await this.readDroppedEntry(childEntry, relativePath, selectedFiles, selectedDirectories);
            }
        },
        removeSelectedFile(index) {
            this.selectedFiles.splice(index, 1);
        },
        // 取消选中的文件夹及其全部内容
        removeSelectedDirectory(directory) {
            const directoryPrefix = `${directory}/`;
            this.selectedDirectories = this.selectedDirectories.filter((item) => item !== directory && !item.startsWith(directoryPrefix));
            this.selectedFiles = this.selectedFiles.filter((item) => !item.relativePath.startsWith(directoryPrefix));
        },
        handleDragover(event) {
            event.preventDefault();
        },
        // 上传文件：先按目录建文件夹，再按目录分组上传
        async uploadFiles() {
            if (this.selectedFiles.length === 0 && this.selectedDirectories.length === 0) {
                this.$message.warning("请选择要上传的文件或文件夹");
                return;
            }
            this.uploading = true;
            this.uploadProgress = 0;

            const directorySet = new Set();
            const filesByDirectory = new Map();
            const basePathParts = this.currentPath.length ? [...this.currentPath] : [];

            this.selectedDirectories.forEach((relativePath) => {
                const directoryParts = relativePath.replace(/\\/g, "/").split("/").filter(Boolean);
                const targetPathParts = [...basePathParts];
                directoryParts.forEach((pathPart) => {
                    targetPathParts.push(pathPart);
                    directorySet.add(targetPathParts.join("\\"));
                });
            });

            this.selectedFiles.forEach((item) => {
                const pathParts = item.relativePath.replace(/\\/g, "/").split("/").filter(Boolean);
                pathParts.pop();
                const targetPathParts = [...basePathParts];
                pathParts.forEach((pathPart) => {
                    targetPathParts.push(pathPart);
                    directorySet.add(targetPathParts.join("\\"));
                });
                const filePath = targetPathParts.join("\\");
                if (!filesByDirectory.has(filePath)) {
                    filesByDirectory.set(filePath, []);
                }
                filesByDirectory.get(filePath).push(item.file);
            });

            const directoryPaths = Array.from(directorySet).sort((a, b) => a.split("\\").length - b.split("\\").length);

            try {
                if (directoryPaths.length > 0) {
                    await fileApi.newFolderApi(directoryPaths, this);
                }
                for (const [filePath, files] of filesByDirectory) {
                    const formData = new FormData();
                    files.forEach((file) => {
                        formData.append("files", file, file.name);
                        formData.append("foreignKeys", "");
                        formData.append("fileTypes", file.name.split(".").pop());
                    });
                    formData.append("filePath", filePath);
                    formData.append("tableName", "default");
                    await fileApi.uploadFileApi(formData, this);
                }
                this.showUploadDialog = false;
                this.$message.success("文件上传成功");
                this.getData();
            } catch (error) {
                this.$message.error("文件夹创建或文件上传失败");
            } finally {
                this.uploading = false;
            }
        },
        formatFileSize(bytes) {
            if (bytes === 0) return "0 B";
            if (bytes == null) return "";
            const k = 1024;
            const sizes = ["B", "KB", "MB", "GB"];
            const i = Math.floor(Math.log(bytes) / Math.log(k));
            return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + " " + sizes[i];
        },
        countModified(lastModified) {
            if (!lastModified) return "";
            const date = new Date(lastModified);
            return Number.isNaN(date.getTime()) ? String(lastModified) : date.toLocaleString();
        },
    },
    created() {
        if (this.roleName !== "管理员") {
            this.$message.error("无权限访问文件管理");
            this.$router.replace("/");
            return;
        }
        this.getData();
    },
    mounted() {
        this.showTime();
        window.addEventListener("keydown", this.handleBackspace);
    },
    beforeDestroy() {
        if (this.timer) {
            clearInterval(this.timer);
            this.timer = "";
        }
        window.removeEventListener("keydown", this.handleBackspace);
    },
};
</script>

<style scoped>
.file-manage {
    height: 100%;
    display: flex;
    flex-direction: column;
    background: #f2f3f5;
    font-family: "sonti", "Arial";
}

.overview-header {
    height: 52px !important;
    flex: 0 0 52px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 18px;
    box-sizing: border-box;
    background: linear-gradient(135deg, #0faeb8 0%, #12b4bd 55%, #28c1c8 100%);
    box-shadow: 0 2px 10px rgba(18, 180, 189, 0.2);
}

.header-left {
    min-width: 0;
    display: flex;
    align-items: center;
    gap: 10px;
}

.header-left img {
    width: 36px;
    height: 36px;
    object-fit: contain;
}

.header-text-left {
    flex-shrink: 0;
    font-size: 21px;
    line-height: 1;
    font-weight: 700;
    letter-spacing: 1px;
    color: #fff;
}

.pe-header-text {
    min-width: 0;
    margin-left: 6px;
    padding-left: 16px;
    border-left: 1px solid rgba(255, 255, 255, 0.38);
    font-size: 15px;
    line-height: 24px;
    font-weight: 500;
    color: rgba(255, 255, 255, 0.92);
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.header-info {
    flex-shrink: 0;
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    justify-content: center;
    gap: 2px;
}

.header-right {
    line-height: 18px;
    font-size: 12px;
    text-align: right;
    color: rgba(255, 255, 255, 0.92);
}

.manage-body {
    flex: 1;
    min-height: 0;
    padding: 12px 15px;
    box-sizing: border-box;
    display: flex;
}

.file-panel {
    flex: 1;
    min-height: 0;
    display: flex;
    flex-direction: column;
    background: #fff;
    border: 1px solid #ebeef5;
    border-radius: 6px;
    overflow: hidden;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
}

.file-toolbar {
    flex-shrink: 0;
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 12px;
    padding: 10px 15px;
    background: #f8f9fa;
    border-bottom: 1px solid #ebeef5;
    flex-wrap: wrap;
}

.breadcrumb-wrap {
    min-width: 0;
    display: flex;
    align-items: center;
}

.search-tip {
    color: #909399;
    font-size: 13px;
}

.toolbar-actions {
    display: flex;
    align-items: center;
    gap: 8px;
    flex-wrap: wrap;
}

.toolbar-actions .el-button + .el-button {
    margin-left: 0;
}

.search-input {
    width: 220px;
    margin-left: 2px;
}

.path-item ::v-deep .el-breadcrumb__inner {
    cursor: pointer !important;
}

.path-item ::v-deep .el-breadcrumb__inner:hover {
    color: #12b4bd;
}

.file-list {
    flex: 1;
    min-height: 0;
    display: flex;
    flex-direction: column;
}

.file-scroll {
    flex: 1;
    min-height: 0;
    overflow-y: auto;
}

.file-item {
    display: flex;
    align-items: center;
    padding: 8px 15px;
    border-bottom: 1px solid #f0f2f5;
    transition: background-color 0.2s;
    cursor: pointer;
    user-select: none;
}

.file-item:hover {
    background-color: #f5f7fa;
}

.file-icon {
    width: 34px;
    height: 34px;
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 14px;
    border-radius: 6px;
    background: #ecf5ff;
    font-size: 20px;
}

.file-info {
    flex: 1;
    min-width: 0;
    display: flex;
    align-items: center;
    gap: 20px;
}

.file-name {
    flex: 1;
    min-width: 0;
    font-weight: 500;
    font-size: 14px;
    color: #303133;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.file-meta {
    flex-shrink: 0;
    font-size: 12px;
    color: #909399;
}

.file-ops {
    flex-shrink: 0;
    display: flex;
    gap: 8px;
    margin-left: 15px;
}

.file-ops .el-button + .el-button {
    margin-left: 0;
}

.empty-state {
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    color: #909399;
}

.empty-icon {
    font-size: 48px;
    margin-bottom: 15px;
    color: #c0c4cc;
}

.file-type-indicator {
    width: 8px;
    height: 8px;
    border-radius: 50%;
    display: inline-block;
    margin-right: 8px;
}

.file-type-pdf {
    background-color: #f56c6c;
}

.file-type-image {
    background-color: #67c23a;
}

.file-type-doc {
    background-color: #409eff;
}

.file-type-other {
    background-color: #909399;
}

.page-footer {
    height: 28px !important;
    flex: 0 0 28px;
    font-size: 13px;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #12b4bd;
}

.upload-area {
    border: 2px dashed #dcdfe6;
    border-radius: 6px;
    padding: 30px;
    text-align: center;
    margin-bottom: 15px;
    transition: border-color 0.3s;
    background: #fafafa;
    cursor: pointer;
}

.upload-area:hover {
    border-color: #12b4bd;
}

.upload-icon {
    font-size: 48px;
    color: #c0c4cc;
    margin-bottom: 15px;
}

.upload-target {
    margin-top: 4px;
    color: #909399;
    font-size: 12px;
}

.selected-upload-panel {
    margin-top: 15px;
    overflow: hidden;
    border: 1px solid #e4e7ed;
    border-radius: 6px;
    background: #fff;
}

.selected-upload-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 10px 14px;
    border-bottom: 1px solid #ebeef5;
    background: #f5f7fa;
}

.selected-upload-header h4 {
    margin: 0;
    color: #303133;
    font-size: 14px;
}

.selected-upload-header span {
    color: #909399;
    font-size: 12px;
}

.selected-upload-list {
    max-height: 260px;
    margin: 0;
    padding: 6px 10px;
    overflow-y: auto;
    list-style: none;
}

.selected-upload-item {
    display: flex;
    align-items: center;
    gap: 10px;
    min-height: 34px;
    padding: 3px 8px;
    border-bottom: 1px solid #f0f2f5;
    border-radius: 4px;
}

.selected-upload-item:last-child {
    border-bottom: none;
}

.selected-upload-item:hover {
    background: #f5f7fa;
}

.selected-upload-icon {
    flex-shrink: 0;
    font-size: 17px;
}

.folder-icon {
    color: #e6a23c;
}

.doc-icon {
    color: #409eff;
}

.selected-upload-name {
    flex: 1;
    min-width: 0;
    overflow: hidden;
    color: #606266;
    font-size: 13px;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.selected-upload-size {
    flex-shrink: 0;
    color: #909399;
    font-size: 12px;
}

.remove-upload-item {
    flex-shrink: 0;
    padding: 0 4px;
    color: #c0c4cc;
    font-size: 20px;
}

.remove-upload-item:hover {
    color: #f56c6c;
}

.upload-progress {
    margin: 0 0 8px;
    color: #606266;
    font-size: 13px;
    text-align: right;
}

@media screen and (max-width: 900px) {
    .overview-header {
        padding: 0 12px;
    }

    .header-text-left {
        font-size: 18px;
    }

    .pe-header-text {
        margin-left: 2px;
        padding-left: 10px;
        font-size: 14px;
    }

    .header-info {
        margin-left: 12px;
    }

    .manage-body {
        padding: 10px;
    }

    .file-meta {
        display: none;
    }
}

@media screen and (max-width: 640px) {
    .overview-header {
        height: 48px !important;
        flex-basis: 48px;
    }

    .header-left img {
        width: 30px;
        height: 30px;
    }

    .header-text-left {
        font-size: 16px;
        letter-spacing: 0;
    }

    .pe-header-text {
        display: none;
    }

    .header-info .header-right:first-child {
        max-width: 150px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    .header-info .header-right:last-child {
        display: none;
    }

    .search-input {
        width: 100%;
        margin-left: 0;
    }
}
</style>
